module.exports = __webpack_public_path__ + "static/media/inc5000-badge.88935dd4.svg";